import { render, staticRenderFns } from "./DepurationFemaleModal.vue?vue&type=template&id=6c3acb9e&scoped=true"
import script from "./DepurationFemaleModal.vue?vue&type=script&lang=js"
export * from "./DepurationFemaleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3acb9e",
  null
  
)

export default component.exports